const MuiTooltip = {
    styleOverrides: {
        tooltip: ({ theme })=>({
                ...theme.typography.body2,
                backgroundColor: theme.palette.background.tooltip,
                color: 'light' === theme.palette.mode ? theme.palette.text.inversePrimary : theme.palette.text.primary,
                padding: theme.spacing(1),
                boxShadow: theme.shadows[5]
            }),
        arrow: ({ theme })=>({
                color: theme.palette.background.tooltip
            })
    }
};
export { MuiTooltip };

//# sourceMappingURL=tooltip-overrides.js.map